import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#999999",
    "col2n": "#FFFFFF"
}
function FacNos018({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M38.05 3.9q0-1-.35-1.85-.4-.5-.5-.6Q36.05.35 35 .1q-.6-.15-1.25-.05-.25.05-.4.1-.2.05-.2.1.05.05.25.05.15 0 .25.05l-15.2 3.8L4.55.35Q4.6.3 4.65.3q.2 0 .25-.05 0-.05-.2-.1-.15-.05-.4-.1-.6-.1-1.25.05Q2 .35.9 1.45q-.15.1-.55.6Q0 2.9 0 3.9q0 2 1.55 3.4 1.5 1.45 3.65 1.45 1.55 0 4.4-.95.1-.05.25-.1.1-.1.3-.2 1.15.85 1.85 2.05.2.4.35.8 1 2.4 2.6 4.05 1.5 1.7 3.1 2.15.45.1.95.15h.1q.45-.05.9-.15 1.65-.45 3.1-2.15 1.6-1.65 2.6-4.05.15-.4.4-.8.7-1.2 1.8-2.05.2.1.3.2.15.05.25.1 2.85.95 4.4.95 2.15 0 3.65-1.45 1.55-1.4 1.55-3.4z"
                    id="FacNos018__Symbol_31_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M34.4 17.95q-.95-.85-2.25-1-.2 0-.25-.05 0-.05.2-.1-1.25-.4-2.55-1.45-3.1-2.5-6.5-9-1.5-3.7-2.95-5.15-2.3-2.4-4.6 0-1.5 1.45-2.95 5.15-3.5 6.5-6.55 9-1.35 1.05-2.55 1.45.2.05.2.1-.05.05-.25.05-1.25.15-2.25 1H1.1Q0 19 0 20.55q0 1.5 1.1 2.5 1.25 1.1 2.85 1.1 1.3 0 3.55-.75-1.1-.45-3.25-1.25l-.2-.15.1-.05h.8q3.45-.55 5.75 2.2.85.9 1.4 2.05l.1.2q.95 2.2 2.55 3.85 1.65 1.55 2.85 1.6h.4q1.15-.05 2.8-1.6 1.6-1.65 2.55-3.85l.1-.2q.55-1.15 1.4-2.05 2.3-2.75 5.8-2.2h.75l.1.05-.2.15q-2.15.8-3.2 1.25 2.2.75 3.5.75 1.65 0 2.85-1.1 1.15-1 1.15-2.5 0-1.55-1.15-2.6h-.05z"
                    id="FacNos018__Symbol_30_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacNos018__Symbol_31_0_Layer0_0_FILL"
                transform="translate(173.5 197.9)"
                id="FacNos018__col1n"
            />
            <use
                xlinkHref="#FacNos018__Symbol_30_0_Layer0_0_FILL"
                transform="translate(174.75 181.25)"
                id="FacNos018__col2n"
            />
        </g></g>
    )
}
export default FacNos018
